import React, { useEffect, useState } from 'react'
import useTitle from 'utils/customHook/useTitle'
import i18n from 'simple-react-i18n'
import CollectivityForm from './CollectivityForm'
import { useParams } from 'react-router'
import EntityPanel from './EntityPanel'
import { Grid } from '@mui/material'
import useActions from 'utils/customHook/useActions'
import { maxBy } from 'lodash'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import UpdatePanel from 'components/updatePanel/UpdatePanel'
import UpdateEntityPanel from './UpdateEntityPanel'
import RpqsAction from 'rpqs/actions/RpqsAction'
import ProgressCard from '../../../components/card/ProgressCard'
import { isRpqsLoaded } from '../../utils/RPQSUtils'

const RpqsDescriptiveApp = () => {
    const {
        collectivityProps,
        rpqs,
        managementUnits,
    } = useSelector(store => ({
        collectivityProps: store.RpqsReducer.collectivity,
        rpqs: store.RpqsReducer.rpqs,
        managementUnits: store.RpqsReducer.managementUnits,
    }), shallowEqual)

    const { annee, idCollectivite } = useParams()
    const dispatch = useDispatch()

    const isLoaded = isRpqsLoaded(rpqs, annee, idCollectivite) && collectivityProps?.id === parseInt(idCollectivite)

    const [collectivity, setCollectivity] = useState({})

    useEffect(() => {
        dispatch(RpqsAction.fetchAllManagementUnits())
    }, [dispatch])

    useEffect(() => {
        if (isLoaded) {
            setCollectivity(collectivityProps)
        }
    }, [collectivityProps, isLoaded])

    useTitle(() => [{
        title: i18n.rpqs,
        href: 'rpqs',
    }, {
        title: rpqs.year || `${i18n.year} ${i18n.unknown}`,
        href: `rpqs/${annee}/collectivite/${idCollectivite}`,
    }, {
        title: rpqs.name || i18n.unknown,
        href: `rpqs/${annee}/collectivite/${idCollectivite}`,
    }, {
        title: i18n.descriptive,
        href: `rpqs/${annee}/collectivite/${idCollectivite}/description`,
    }], [rpqs, annee, idCollectivite])

    useActions(() => {
        return {
            export: () => {},
        }
    }, [])

    const year = rpqs.year
    const nbManagementEntities = collectivity?.managementEntities?.length
    const lastUpadatedEntity = collectivity.managementEntities && maxBy(collectivity.managementEntities, 'updateDate')
    const managementUnitsFiltered = managementUnits.filter(m => collectivity.link_managementUnits?.some(l => l.managementUnitCode === m.id))

    if (!isLoaded) {
        return <ProgressCard indeterminate round />
    }

    return (
        <Grid
            container
            columnSpacing={1}
            sx={{ padding: 1 }}
        >
            <Grid container direction={'column'} size={9} rowSpacing={1}>
                <CollectivityForm
                    collectivity={collectivity}
                    nbManagementEntities={nbManagementEntities}
                    setCollectivity={setCollectivity}
                />
                {/* Other collectivity form */}
                <EntityPanel
                    year={year}
                    managementEntities={managementUnitsFiltered}
                />
            </Grid>
            <Grid container direction={'column'} size={3} rowSpacing={1}>
                <UpdatePanel
                    updateLogin={collectivity.updateLogin}
                    updateDate={collectivity.updateDate}
                />
                {lastUpadatedEntity &&
                    <Grid size={12}>
                        <UpdateEntityPanel
                            entityName={lastUpadatedEntity.name}
                            updateLogin={lastUpadatedEntity.updateLogin}
                            updateDate={lastUpadatedEntity.updateDate}
                        />
                    </Grid>
                }
            </Grid>
        </Grid>
    )
}

export default RpqsDescriptiveApp
